var React = require('react');
var Shopify = require('./shopify');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;
var ReactDOM = require('react-dom');
var CatMenus = require('./cat-menu');

module.exports = React.createClass({

  getInitialState: function() {
    return { title: this.props.title ? this.props.title : "" };
  },

  componentDidMount: function() {
    if (this.props.image) {
      var rootDiv = jQuery(this.refs.root);

      rootDiv.css("background", 'url("' + this.props.image + '") center bottom no-repeat');
    }
  },

  toggleMenu: function() {
    this.refs.catMenus.toggleMenus();
  },

  setContent: function(title, image) {

    this.setState({ title: title });

    var rootDiv = jQuery(this.refs.root);

    rootDiv.css("background", 'url("' + image + '") center bottom no-repeat');
  },

  render: function() {
    return <header ref="root" className={"full-width mobile"}>
        <div className="container">
            <div id="cat-menu-wrap">
                <h1>{this.state.title}</h1>
                <h2 ref="subHeading" onClick={this.toggleMenu} className="cat-menu-heading">Shop by Category</h2>
                <CatMenus ref="catMenus" menus={this.props.menus}
                                      gender={this.props.gender}/>            
            </div>            

        </div>
    </header>
  }
});